// What clicking an activity row opens, shared by the Today's-tasks AI Activity panel and the Smart
// Note's Recent activity feed so the same row kind gets the same detail view in both places.

// The plan/promise behind a row: payment rows carry it as originatingActionId; a plan/promise
// "started" row is the action itself. A chat-created task's own lifecycle row is internal plumbing
// (the calendar TaskCreated row is the one that opens), so it is excluded here.
export function planActionIdOf(a) {
  if (a.originatingActionId) return a.originatingActionId;
  if (a.eventName === "ActionStarted" && a.primaryEntityId && !/^task\b/i.test(a.title ?? a.displayText ?? ""))
    return a.primaryEntityId;
  return null;
}

// "plan" | "task" | "note" | null.
export function activityOpens(a) {
  if (planActionIdOf(a)) return "plan";
  if (a.eventName === "TaskCreated" && a.primaryEntityId) return "task";
  if (a.eventName === "NoteCreated") return "note";
  return null;
}

// A created task as a calendar-shaped item for the calendar's own detail modal (EventDetails). The
// row carries the calendar item id (its primary entity), title and due date; the modal fetches the
// rest (description, customer) from the item detail endpoint.
export function taskItemFromActivity(a) {
  const due = a.scheduledFor ? new Date(a.scheduledFor) : null;
  return {
    kind: "task",
    uid: `${a.primaryEntityId}@ontik.com`,
    summary: a.displayText ?? a.title ?? "",
    due: due && !Number.isNaN(due.getTime()) ? due : null,
    allDay: false,
  };
}
